// Worked examples for the Three-Point Estimate calculator. All illustrative: the tasks
// and numbers are invented to show the method. Addressable as #example=<id>.

export const EXAMPLES = [
  {
    id: "checkout-revamp",
    name: "Checkout revamp, in days",
    description: "Seven tasks, one with a long pessimistic tail. Illustrative.",
    state: {
      unit: "days",
      widen: "as-stated",
      together: "some",
      target: 30,
      tasks: [
        { label: "Design review", low: 1, likely: 2, high: 4 },
        { label: "Payment provider switch", low: 3, likely: 5, high: 15 },
        { label: "Address form", low: 1, likely: 2, high: 3 },
        { label: "Order summary page", low: 2, likely: 3, high: 6 },
        { label: "Tests and fixes", low: 2, likely: 4, high: 10 },
        { label: "Analytics events", low: 0.5, likely: 1, high: 2 },
        { label: "Release and monitoring", low: 1, likely: 1, high: 3 },
      ],
    },
  },
  {
    id: "migration",
    name: "Database migration, in weeks",
    description: "Four phases that tend to slip together. Illustrative.",
    state: {
      unit: "weeks",
      widen: "wider",
      together: "strong",
      target: 12,
      tasks: [
        { label: "Schema mapping", low: 1, likely: 2, high: 4 },
        { label: "Dual writes", low: 2, likely: 3, high: 6 },
        { label: "Backfill", low: 1, likely: 2, high: 5 },
        { label: "Cut-over and clean-up", low: 1, likely: 1.5, high: 3 },
      ],
    },
  },
  {
    id: "remaining-backlog",
    name: "Remaining backlog, in points",
    description: "Five epics sized in points, for a sprint forecast. Illustrative.",
    state: {
      unit: "points",
      widen: "as-stated",
      together: "independent",
      target: 120,
      tasks: [
        { label: "Onboarding", low: 13, likely: 20, high: 34 },
        { label: "Billing", low: 8, likely: 13, high: 21 },
        { label: "Permissions", low: 13, likely: 21, high: 40 },
        { label: "Reporting", low: 8, likely: 13, high: 30 },
        { label: "Admin tools", low: 5, likely: 8, high: 13 },
      ],
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
